import React from 'react';
import { Box, Separator, Text } from '@myob/myob-widgets';
import { MinTotalPriceViewProps } from './type';

export const MinTotalPriceView: React.FC<MinTotalPriceViewProps> = ({
  isAnnualPrice,
  minTotalPrice,
  productItems,
  showSeparator = true,
  className
}) => (
  <Box className={className} data-testid='min-monthly-total'>
    {showSeparator && (
    <Separator
      data-testid='total-price-separator'
      marginTop='sm'
      marginBottom='sm'
    />
    )}
    <Box
      display='flex'
      justifyContent='space-between'
      flexDirection='row'
    >
      <Box
        display='flex'
        alignItems='end'
      >
        <Text
          fontWeight='bold'
          fontSize='sm'
          marginBottom='clear'
        >
          Min. {isAnnualPrice ? 'Yearly' : 'Monthly'} total
        </Text>
        <Text
          fontSize='xs'
          marginBottom='clear'
        >
          &nbsp;(inc. GST)
        </Text>
      </Box>
      <Text
        marginBottom='clear'
        tone='neutralStrongest'
      >
        {' '}${minTotalPrice} {productItems[0].currency}
      </Text>
    </Box>
  </Box>
);